import { render, staticRenderFns } from "./OrderQuoteDetail.vue?vue&type=template&id=51fa337c"
import script from "./OrderQuoteDetail.vue?vue&type=script&lang=js"
export * from "./OrderQuoteDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports